import { ReactNode } from 'react';
import NavHamburger from './Navbar/NavHamburger';
import { ThemeUICSSObject } from 'theme-ui';
import { isPwaContext } from '../utils/pwa';

const LoggedInContainer = ({
  children,
  style,
  showNavHamburger = true,
}: {
  children: ReactNode;
  style?: ThemeUICSSObject;
  // Pages that put NavMenuButton in their own header turn this off.
  showNavHamburger?: boolean;
}): JSX.Element => {
  return (
    <div
      sx={{
        display: 'flex',
        height: '100%',
        // CSS, so the first paint already has the wide-screen side column.
        flexDirection: ['column', 'row'],
        ...style,
      }}
    >
      {/* Hamburger opens the nav, which is hidden in the installed PWA — so
          hide the icon too and reclaim the space at the top of the page. */}
      {showNavHamburger && !isPwaContext() && <NavHamburger />}
      {children}
    </div>
  );
};

export default LoggedInContainer;
